import type { Node } from '@xyflow/react';
import * as Y from 'yjs';

export interface NodeContent {
  textContent?: string;
  imageUrl?: string;
}

export function extractPlainTextFromHtml(html: string): string {
  if (!html) return '';
  let text = html;
  text = text.replace(/<br\s*\/?>/gi, '\n');
  text = text.replace(/<\/p>|<\/div>|<\/li>|<\/tr>/gi, '\n');
  text = text.replace(/<[^>]*>/g, ' ');
  text = text.replace(/&nbsp;/g, ' ');
  text = text.replace(/&amp;/g, '&');
  text = text.replace(/&lt;/g, '<');
  text = text.replace(/&gt;/g, '>');
  text = text.replace(/[ \t]+/g, ' ');
  text = text.replace(/\n{3,}/g, '\n\n');
  return text.trim();
}

export function getBlockTextFromYDoc(ydoc: Y.Doc | undefined, nodeId: string): string {
  if (!ydoc) return '';
  const fragment = ydoc.getXmlFragment(`richtext-${nodeId}`);
  const html = fragment.toString();
  return extractPlainTextFromHtml(html);
}

export function getNodeLabel(node: Node): string {
  const data = node.data as Record<string, unknown> | undefined;
  const title = typeof data?.title === 'string' ? data?.title : '';
  const label = typeof data?.label === 'string' ? data?.label : '';
  const text = typeof data?.text === 'string' ? data?.text : '';
  return title || label || text || node.id;
}

export function getNodeContent(node: Node, ydoc?: Y.Doc): NodeContent {
  const data = node.data as Record<string, unknown> | undefined;

  if (node.type === 'block') {
    const textContent = getBlockTextFromYDoc(ydoc, node.id);
    return textContent ? { textContent } : {};
  }

  if (node.type === 'image') {
    const src = typeof data?.src === 'string' ? data?.src : '';
    return src ? { imageUrl: src } : {};
  }

  if (node.type === 'stickyNote') {
    const textContent = typeof data?.text === 'string' ? data?.text : '';
    return textContent ? { textContent } : {};
  }

  if (node.type === 'generator') {
    const lastOutput = typeof data?.lastOutput === 'string' ? data?.lastOutput : '';
    return lastOutput ? { textContent: lastOutput } : {};
  }

  const content = typeof data?.content === 'string' ? data?.content : '';
  const textContent = extractPlainTextFromHtml(content);
  return textContent ? { textContent } : {};
}
